<!--
frontend-author:vaishnavi,
backend-author: Rajalakshmi,
page-name :TDS details.vue,
page-description :Sales by credit for invoice,
started at : 15-Apr-2019,
edited at :16-Apr-2019.
-->
<!-- Html code for Sales by Customer-->
<template>
  <div>
    <b-row class="reports-header px-pad border-bottom" style="height:42px">
      <b-col xl="6" lg="6" md="6" sm="6" class="px-0">
        <GlobalDateRangePicker
          class="pr-3"
          ref="daterangeupdate"
          :singleDatePicker="false"
          v-on:setDateRange="getDateRange($event)"
          :fromDate="from_date"
          :toDate="to_date"
        />
      </b-col>

      <b-col xl="6" lg="6" md="6" sm="6" class="px-0">
        <router-link class="event-link float-right mt-2" :to="{ name : 'Reports'}">
          <i class="la la-remove la-lg text-decoration-none text-dark"></i>
        </router-link>
        <!-- Download excel -->
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown float-right mr-2">
          <template slot="button-content">
            <i class="la la-navicon la-lg"></i>
          </template>
          <b-dropdown-item @click="exportModal()" class="dropdown-no-btn">
            <span class="la la-download mx-2"></span>Export Withholding tax
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <b-row class="pt-2">
      <b-col lg="12" xl="12" md="12" sm="12" class="px-0">
        <div class="text-center text-normal">
          <p class="mb-1">{{ org_name }}</p>
          <h4 class="fw-semi-bold">Withholding Tax</h4>
          <p
            class="text-sm text-muted mb-2"
          >{{ 'From ' + getDateFormat(from_date) +' To '+ getDateFormat(to_date) }}</p>
        </div>
        <!-- <GlobalLoader v-show="loader"/> -->
        <div class="table-responsive" id="reportScrollCol">
          <!--  Invoice Table-->
          <table class="table table-bordered reports-table-border table-no-bordered">
            <!--  Invoice Table head-->
            <thead class="tbl-col">
              <tr>
                <th>
                  <router-link
                    :to="{ name : 'TDSDetailsReport',query: {page: page,show: show,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc' ,from_date:$route.query.from_date,to_date:$route.query.to_date,label:'cus_display_name'} }"
                    class="text-dark text-decoration-none"
                  >
                    Customer Name
                    <small class="text-muted" v-if="label == 'cus_display_name'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th class="text-right">
                  <router-link
                    :to="{ name : 'TDSDetailsReport',query: {page: page,show: show,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc' ,from_date:$route.query.from_date,to_date:$route.query.to_date,label:'export_withheld_amount'} }"
                    class="text-dark text-decoration-none"
                  >
                    Withholding Tax(FCY)
                    <small
                      class="text-muted"
                      v-if="label == 'export_withheld_amount'"
                    >
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th class="text-right">
                  <router-link
                    :to="{ name : 'TDSDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'withheld_amount'} }"
                    class="text-dark text-decoration-none"
                  >
                    Withholding Tax(BCY)
                    <small class="text-muted" v-if="label == 'withheld_amount'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>

                <!-- Customize column -->
              </tr>
            </thead>
            <!--  Sales by Customer Table body and data -->
            <template v-if="lists.length == 0">
              <tbody>
                <tr>
                  <td colspan="4" class="text-center">No data to display</td>
                </tr>
              </tbody>
            </template>
            <template v-else>
              <tbody>
                <tr v-for="item in lists" :key="item.id" @click="oldRoute = $route.query">
                  <td style="width:180px !important">
                    <router-link
                      class="text-decoration-none"
                      v-if="RoutePermission(false,'','invoice','customer','index')"
                      :to="{ name : 'CustomerView',params:{id:item.cus_id }}"
                    >
                      <span class="text">{{ item.cus_display_name }}</span>
                    </router-link>
                    <template v-else>
                      <span class="text">{{ item.cus_display_name }}</span>
                    </template>
                  </td>
                  <td class="text-right">
                    <router-link
                      class="text-decoration-none"
                      :to="{ name : 'TDSDetailsFilter',params:{id: item.cus_id},query: {name:item.cus_display_name,id: item.cus_id,from_date:$route.query.from_date,to_date:$route.query.to_date,} }"
                    >
                      {{ getDetails(
                      $AppDetails.currency_details,
                      item.cus_currency,
                      "currency_symbol"
                      )+" "+Number(item.export_withheld_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                    </router-link>
                  </td>
                  <td class="text-right">
                    <router-link
                      class="text-decoration-none"
                      :to="{ name : 'TDSDetailsFilter',params:{id: item.cus_id},query: {name:item.cus_display_name,id: item.cus_id,from_date:$route.query.from_date,to_date:$route.query.to_date,} }"
                    >{{ orgCurrencySymbol+" "+Number(item.withheld_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                  </td>

                  <!-- Customize column -->
                </tr>
                <tr>
                  <td colspan="2" class="fw-semi-bold text-right">TOTAL ({{total_count}})</td>

                  <td
                    class="fw-semi-bold text-right"
                  >{{ orgCurrencySymbol+" "+Number(total_amount.withheld_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                </tr>
              </tbody>
            </template>
          </table>
          <p class="ml-4" v-if="lists.length != 0">
            Amount is displayed in your base currency
            <b-badge variant="success" size="xs" style="height:20px">{{orgCurrency}}</b-badge>
          </p>
        </div>
      </b-col>
    </b-row>

    <!-- Sales by Item pagination and data showing -->

    <b-row
      v-if="lists.length > 0||arrow"
      style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
      class="px-pad"
    >
      <b-col xl="5" md="6" lg="6" sm="8" class="mt-2 pt-1 px-0">
        <nav v-if="lists.length > 0" class="float-left">
          <p>
            Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }}
            of {{ total_count }} entries
            <span
              class="btn-group dropdown"
            >
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                size="xs"
                :show="false"
                :text="count"
                left
              >
                <router-link
                  :to="{ name : 'TDSDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 10,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'TDSDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 25,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'TDSDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: 50,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                </router-link>
              </b-dropdown>
            </span> rows per page
          </p>
        </nav>
      </b-col>
      <b-col xl="2" md="2" lg="2" sm="4" style="text-align: center;" class="mt-2 pt-1 px-0">
        <div v-if="arrow">
          <a @click="left('#reportScrollCol')" class="mr-2">
            <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>
          </a>
          <a @click="right('#reportScrollCol')">
            <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>
          </a>
        </div>
      </b-col>
      <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
        <template v-if="show<total_count">
          <nav class="float-right">
            <ul class="pagination">
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'TDSDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label} }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'TDSDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: count,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label} }"
                >First</router-link>
              </li>
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'TDSDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label} }"
                  >Previous</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Previous</a>
                </template>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'TDSDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label } }"
                  >Next</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Next</a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'TDSDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: Math.ceil(total_count / count),show: count,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label } }"
                >Last</router-link>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'TDSDetailsReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label } }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </template>
              </li>
            </ul>
          </nav>
        </template>
      </b-col>
    </b-row>
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Withholding Tax'"
      @downloaded="export_modal=false"
    />
  </div>
</template>
<!-- Sales by Customer  Script -->
<script>
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll

import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import Vue from "vue";
import moment from "moment";
import $ from "jquery";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import DatePicker from "vue2-datepicker";
import { formatDate } from "@/mixins/formatDate";
function getPageTdsDetails(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const sort = routeTo.query.sort || "";
  const label = routeTo.query.label || "";
  store
    .dispatch("reports/fetchTDSDetailsLists", {
      page: currentPage,
      show: show,
      sort: sort,
      label: label,
      query: routeTo.query
    })

    .then(() => {
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.sort = sort;
      routeTo.params.label = label;
      next();
    });
}
export default {
  components: {
    DatePicker,
    VueBootstrapTypeahead
  },
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    label: [String, Number],
    sort: [String, Number]
  },
  name: "TDSDetailsReport",
  mixins: [formatDate, scrollTable],
  data() {
    return {
      arrow: false,
      export_data: [],
      export_modal: false,
      export_xl: {
        "Customer Name": "cus_display_name",
        "Withholding Tax(FCY)": "export_withheld_amount",
        "Withholding Tax(BCY)": "withheld_amount"
      },

      show_by: 0,
      cus_detail_id: "",
      loader: false,
      error_show: false,
      from_date:
        this.$route.query.from_date ||
        this.formatDate(moment().startOf("month")),
      to_date:
        this.$route.query.to_date || this.formatDate(moment().endOf("month")),

      org_name: this.$AppDetails.organization.comp_name || ""
    };
  },

  updated() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },

  methods: {
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      this.$root.$emit("bv::show::modal", "exportdata");
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const response = await store
        .dispatch("reports/fetchTdsDetailsExportLists", {
          page: currentPage,
          show: show,
          sort: sort,
          label: label,

          query: this.$route.query
        })
        .then(() => {
          return this.export;
        });
      return response;
    },

    customerlist(event) {
      if (event != "") {
        store.dispatch("general/fetchCustomerData", event).then(() => {
          this.customers = this.customer_filter_list;
        });
      }
    },
    getPresentValue(arr, prop, val) {
      var hasMatch = false;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = true;
          break;
        }
      }
      return hasMatch;
    },
    closeModal(id) {
      this.$refs[id].hide();
    },

    getDateRange(event) {
      this.from_date = event.startDate;
      this.to_date = event.endDate;
      this.$router.push({
        name: this.$route.name,
        query: {
          from_date: this.from_date,
          to_date: this.to_date,
          label: this.label,
          sort: this.sort
        }
      });
    },
    changeSelectOption(field, value) {
      Vue.set(this, field, value);
    }
  },
  created() {
    if (
      Object.entries(this.$route.query).length === 0 &&
      this.$route.query.constructor === Object
    ) {
      this.$router.push({
        name: this.$route.name,
        query: {
          from_date: this.from_date,
          to_date: this.to_date,
          label: this.label,
          sort: this.sort
        }
      });
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    getPageTdsDetails(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    typeof this.$refs.run != "undefined" ? this.$refs.run.hide() : "";
    getPageTdsDetails(routeTo, next);
  },
  computed: {
    ...mapState({
      customer_filter_list: state => state.general.customer_filter_list,
      lists: state => state.reports.lists,
      total_count: state => state.reports.total_count,
      count: state => state.reports.count,
      total_amount: state => state.reports.total_amount,
      export: state => state.reports.export
    }),
    ...mapGetters(["orgCurrencySymbol", "orgCurrency"]),
    oldRoute: {
      get() {
        return this.$store.state.general.oldRoute;
      },
      set(val) {
        this.$store.state.general.oldRoute = val;
      }
    }
  }
};
</script>

<!--  Sales by Customer style -->
<style scoped>
.pagination > .page-item > .page-link,
.pagination > .page-item > span {
  border-radius: unset;
  margin: 0;
  background: transparent;
}
.ver-align {
  padding-top: 10px;
  text-decoration: none;
}
.content {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  padding: 40px 40px 60px;
  background-color: #fff;
}
</style>
